export default "__VITE_ASSET__ldYTEJVE__"